import { Component, Input } from '@angular/core';
import { FileServiceService } from '../service/file-service.service';

@Component({
  standalone: false,
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css']
})
export class ProgressBarComponent {
  @Input() currentStep = 1;

  steps = [
    'Enter\nReference ID',
    'Contact Information &\nSecurity Verification',
    'Routing',
    'File Upload'
  ];

  constructor(public service: FileServiceService) { }
}
